export default __webpack_public_path__ + "static/media/brotherjimmys.653ee89c.jpeg";